/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Generated by `shared/errorzen/errorzen/registry/generate.py` from the
 * neutral source `error_codes.json` plus the seeded
 * `errorzen.problem_type_base_uri` configzen base, resolved ONCE at
 * generation time. The `PROBLEM_TYPE_URIS` values below are baked-in
 * constants — this module performs no runtime lookups.
 *
 * Regenerate with:
 *     python3 shared/errorzen/errorzen/registry/generate.py
 *
 * A hand-edit here is rejected by the errorzen-registry-parity
 * pre-commit hook / CI job (scripts/check_errorzen_registry_parity.py).
 */
import { z } from 'zod'

export const KnownErrorCodeSchema = z.enum([
  'ACCESS.ORG_SCOPE_VIOLATION',
  'ACCESS.PERMISSION_DENIED',
  'ACCESS.WORKSPACE_NOT_ALLOWED',
  'AUTH.FORBIDDEN',
  'AUTH.INVALID_CREDENTIALS',
  'AUTH.SERVICE_TOKEN_UNAVAILABLE',
  'AUTH.TOKEN_EXPIRED',
  'AUTH.TOKEN_MISSING',
  'AUTH.UNAUTHENTICATED',
  'CONFIG.ORG_NOT_PROVISIONED',
  'CONFIG.ORG_PROVISIONING_FAILED',
  'CONFIG.ORG_PROVISIONING_INCOMPLETE',
  'CONFIG.PROVIDER_CREDENTIALS_INVALID',
  'CONFIG.SECRET_MISSING',
  'DATA.EXTRACTION_PROFILE_CONFLICT',
  'DATA.PIPELINE_INPUT_INVALID',
  'DATA.PIPELINE_STAGE_CRASHED',
  'DATA.QUERY_FAILED',
  'DATA.QUERY_TIMEOUT',
  'DATA.SCOPE_INVALID',
  'DATA.BACKFILL_CONFIRMATION_REQUIRED',
  'EVALZEN.FILTER_REQUIRED',
  'EVALZEN.TOOL_UNKNOWN',
  'EVALZEN.SUITE_NOT_FOUND',
  'EVALZEN.SUITE_EXISTS',
  'EVALZEN.SUITE_EMPTY',
  'EVALZEN.PLATFORM_SUITE_READONLY',
  'EVALZEN.CASE_EXISTS',
  'EVALZEN.CASE_NOT_FOUND',
  'EVALZEN.PIN_INVALID',
  'EVALZEN.INPUT_INVALID',
  'EVALZEN.PLATFORM_ONLY_SUITE',
  'EVALZEN.EXPECTED_OUTPUT_INVALID',
  'EVALZEN.THRESHOLDS_INVALID',
  'EVALZEN.RUN_NOT_FOUND',
  'EVALZEN.RUN_IN_PROGRESS',
  'EVALZEN.JOB_NOT_FOUND',
  'EVALZEN.NO_BASELINE',
  'EVALZEN.BASELINE_RUN_INVALID',
  'EVALZEN.LANGFUSE_UNAVAILABLE',
  'EVALZEN.CONFIG_MISSING',
  'EVALZEN.CANDIDATE_NOT_SERVED',
  'EVALZEN.CANDIDATE_NOT_EXERCISED',
  'EVALZEN.TOOL_COST_CEILING',
  'EVALZEN.TIER_CAP_EXCEEDED',
  'EVALZEN.RUNNER_NOT_PROVISIONED',
  'EVALZEN.EVAL_WORKSPACE_UNRESOLVED',
  'EVALZEN.AGENT_UNAVAILABLE',
  'EVALZEN.TAXONOMY_NOT_CONFIGURED',
  'EVALZEN.REQUIREMENT_NOT_MET',
  'EVALZEN.RUNNER_FORBIDDEN',
  'EVALZEN.AGENT_TIMEOUT',
  'EVALZEN.TRACE_UNAVAILABLE',
  'EVALZEN.GATE_IN_PROGRESS',
  'EVALZEN.GATE_NOT_PASSED',
  'EVALZEN.GATE_NOT_COVERED_UNACKNOWLEDGED',
  'EVALZEN.REVIEW_NOT_ENABLED',
  'EVALZEN.REVIEW_QUEUE_MISSING',
  'EVALZEN.REVIEW_UNSUPPORTED',
  'EVALZEN.REVIEW_CONFIG_CONFLICT',
  'EVALZEN.IMPORT_IN_PROGRESS',
  'EVALZEN.SUITE_ARCHIVED',
  'EVALZEN.ORG_AGENT_SUITE_UNSUPPORTED',
  'INTERNAL.CACHE_UNAVAILABLE',
  'INTERNAL.UNAVAILABLE',
  'INTERNAL.UNHANDLED',
  'LLM.AGENT_NOT_FOUND',
  'LLM.BUDGET_EXHAUSTED',
  'LLM.CALL_TIMEOUT',
  'LLM.CONTEXT_TOO_LARGE',
  'LLM.DIMENSIONS_NOT_CONFIGURABLE',
  'LLM.DISPATCH_EXHAUSTED',
  'LLM.KEY_NOT_CONFIGURED',
  'LLM.KEY_LOOKUP_UNAVAILABLE',
  'LLM.MODEL_CLASS_ENDPOINT_MISMATCH',
  'LLM.MODEL_CLASS_NOT_COVERED',
  'LLM.MODEL_CLASS_STRANDED',
  'LLM.MODEL_DISABLED',
  'LLM.MODEL_KILL_SWITCHED',
  'LLM.MODEL_NOT_ASSIGNED',
  'LLM.MODEL_NOT_EMBEDDING',
  'LLM.MODEL_NOT_FOUND',
  'LLM.MODEL_NOT_IN_CATALOG',
  'LLM.MODEL_NOT_IN_ORG_ALLOWLIST',
  'LLM.MODEL_OUT_OF_CLASS',
  'LLM.NO_EMBEDDING_MODEL_AVAILABLE',
  'LLM.NO_EVALUATION_MODEL_AVAILABLE',
  'LLM.OUTPUT_EMPTY',
  'LLM.OUTPUT_UNPARSEABLE',
  'LLM.PARAM_REJECTED',
  'LLM.PROVIDER_AUTH_FAILED',
  'LLM.PROVIDER_BAD_REQUEST',
  'LLM.PROVIDER_DISABLED',
  'LLM.PROVIDER_ENDPOINT_MISCONFIGURED',
  'LLM.PROVIDER_NOT_FOUND',
  'LLM.PROVIDER_QUOTA_EXHAUSTED',
  'LLM.PROVIDER_RATE_LIMITED',
  'LLM.PROVIDER_TIMEOUT',
  'LLM.PROVIDER_UNREACHABLE',
  'LLM.PROVIDER_VALIDATION_FAILED',
  'LLM.UPSTREAM_FAILED',
  'LLM.UPSTREAM_TIMEOUT',
  'PPA.ARCHIVE_REJECTED',
  'PPA.CHECKLIST_SUGGESTION_STALE',
  'PPA.CONFLICT_ALREADY_RESOLVED',
  'PPA.FACT_SUPERSEDED',
  'PPA.FILE_TOO_LARGE',
  'PPA.INGESTION_RUNNING',
  'PPA.INVALID_RESULT_FOR_DIMENSION',
  'PPA.INVALID_STATUS_TRANSITION',
  'PPA.NO_DEFAULT_FRAMEWORK',
  'PPA.NO_SOURCES',
  'PPA.ORGANIZATION_ARCHIVED',
  'PPA.VERSION_IMMUTABLE',
  'PPA.VERSION_NOT_PUBLISHED',
  'PPA.WORK_PRODUCT_APPROVED',
  'PPA.WORK_PRODUCT_NOT_APPROVED',
  'RESOURCE.ALREADY_EXISTS',
  'RESOURCE.CONFLICT',
  'RESOURCE.METHOD_NOT_ALLOWED',
  'RESOURCE.NOT_FORWARDABLE',
  'RESOURCE.NOT_FOUND',
  'RESOURCE.RATE_LIMITED',
  'SESSION.CONFIRM_TOKEN_EXPIRED',
  'UPSTREAM.BAD_RESPONSE',
  'UPSTREAM.TIMEOUT',
  'UPSTREAM.UNAVAILABLE',
  'VALIDATION.INVALID_WEIGHTS',
  'VALIDATION.MALFORMED_REQUEST',
  'VALIDATION.MODEL_CAPABILITY_MISSING',
  'VALIDATION.PAYLOAD_TOO_LARGE',
  'VALIDATION.REQUEST_INVALID',
  'VALIDATION.SCHEMA_MISMATCH',
  'VALIDATION.UNSUPPORTED_MEDIA_TYPE',
  'VALIDATION.OBJECTIVE_NOT_RESEARCHABLE',
  'ZENVECTOR.DIMENSION_MISMATCH',
  'ZENVECTOR.MIGRATION_IN_PROGRESS',
  'ZENVECTOR.MIGRATION_STATE_INVALID',
  'ZENVECTOR.MODEL_NOT_EMBEDDING',
  'ZENVECTOR.NAMESPACE_NOT_FOUND',
])

export type KnownErrorCode = z.infer<typeof KnownErrorCodeSchema>

export const CODE_TO_STATUS: Record<KnownErrorCode, number> = {
  'ACCESS.ORG_SCOPE_VIOLATION': 403,
  'ACCESS.PERMISSION_DENIED': 403,
  'ACCESS.WORKSPACE_NOT_ALLOWED': 403,
  'AUTH.FORBIDDEN': 403,
  'AUTH.INVALID_CREDENTIALS': 401,
  'AUTH.SERVICE_TOKEN_UNAVAILABLE': 503,
  'AUTH.TOKEN_EXPIRED': 401,
  'AUTH.TOKEN_MISSING': 401,
  'AUTH.UNAUTHENTICATED': 401,
  'CONFIG.ORG_NOT_PROVISIONED': 503,
  'CONFIG.ORG_PROVISIONING_FAILED': 502,
  'CONFIG.ORG_PROVISIONING_INCOMPLETE': 409,
  'CONFIG.PROVIDER_CREDENTIALS_INVALID': 422,
  'CONFIG.SECRET_MISSING': 503,
  'DATA.EXTRACTION_PROFILE_CONFLICT': 409,
  'DATA.PIPELINE_INPUT_INVALID': 422,
  'DATA.PIPELINE_STAGE_CRASHED': 500,
  'DATA.QUERY_FAILED': 500,
  'DATA.QUERY_TIMEOUT': 504,
  'DATA.SCOPE_INVALID': 422,
  'DATA.BACKFILL_CONFIRMATION_REQUIRED': 428,
  'EVALZEN.FILTER_REQUIRED': 422,
  'EVALZEN.TOOL_UNKNOWN': 404,
  'EVALZEN.SUITE_NOT_FOUND': 404,
  'EVALZEN.SUITE_EXISTS': 409,
  'EVALZEN.SUITE_EMPTY': 422,
  'EVALZEN.PLATFORM_SUITE_READONLY': 403,
  'EVALZEN.CASE_EXISTS': 409,
  'EVALZEN.CASE_NOT_FOUND': 404,
  'EVALZEN.PIN_INVALID': 422,
  'EVALZEN.INPUT_INVALID': 422,
  'EVALZEN.PLATFORM_ONLY_SUITE': 409,
  'EVALZEN.EXPECTED_OUTPUT_INVALID': 422,
  'EVALZEN.THRESHOLDS_INVALID': 422,
  'EVALZEN.RUN_NOT_FOUND': 404,
  'EVALZEN.RUN_IN_PROGRESS': 409,
  'EVALZEN.JOB_NOT_FOUND': 404,
  'EVALZEN.NO_BASELINE': 409,
  'EVALZEN.BASELINE_RUN_INVALID': 422,
  'EVALZEN.LANGFUSE_UNAVAILABLE': 503,
  'EVALZEN.CONFIG_MISSING': 503,
  'EVALZEN.CANDIDATE_NOT_SERVED': 422,
  'EVALZEN.CANDIDATE_NOT_EXERCISED': 422,
  'EVALZEN.TOOL_COST_CEILING': 422,
  'EVALZEN.TIER_CAP_EXCEEDED': 422,
  'EVALZEN.RUNNER_NOT_PROVISIONED': 409,
  'EVALZEN.EVAL_WORKSPACE_UNRESOLVED': 409,
  'EVALZEN.AGENT_UNAVAILABLE': 409,
  'EVALZEN.TAXONOMY_NOT_CONFIGURED': 409,
  'EVALZEN.REQUIREMENT_NOT_MET': 409,
  'EVALZEN.RUNNER_FORBIDDEN': 502,
  'EVALZEN.AGENT_TIMEOUT': 504,
  'EVALZEN.TRACE_UNAVAILABLE': 503,
  'EVALZEN.GATE_IN_PROGRESS': 409,
  'EVALZEN.GATE_NOT_PASSED': 409,
  'EVALZEN.GATE_NOT_COVERED_UNACKNOWLEDGED': 409,
  'EVALZEN.REVIEW_NOT_ENABLED': 409,
  'EVALZEN.REVIEW_QUEUE_MISSING': 409,
  'EVALZEN.REVIEW_UNSUPPORTED': 409,
  'EVALZEN.REVIEW_CONFIG_CONFLICT': 409,
  'EVALZEN.IMPORT_IN_PROGRESS': 409,
  'EVALZEN.SUITE_ARCHIVED': 409,
  'EVALZEN.ORG_AGENT_SUITE_UNSUPPORTED': 409,
  'INTERNAL.CACHE_UNAVAILABLE': 503,
  'INTERNAL.UNAVAILABLE': 503,
  'INTERNAL.UNHANDLED': 500,
  'LLM.AGENT_NOT_FOUND': 404,
  'LLM.BUDGET_EXHAUSTED': 429,
  'LLM.CALL_TIMEOUT': 504,
  'LLM.CONTEXT_TOO_LARGE': 422,
  'LLM.DIMENSIONS_NOT_CONFIGURABLE': 422,
  'LLM.DISPATCH_EXHAUSTED': 503,
  'LLM.KEY_NOT_CONFIGURED': 503,
  'LLM.KEY_LOOKUP_UNAVAILABLE': 503,
  'LLM.MODEL_CLASS_ENDPOINT_MISMATCH': 422,
  'LLM.MODEL_CLASS_NOT_COVERED': 422,
  'LLM.MODEL_CLASS_STRANDED': 409,
  'LLM.MODEL_DISABLED': 422,
  'LLM.MODEL_KILL_SWITCHED': 503,
  'LLM.MODEL_NOT_ASSIGNED': 422,
  'LLM.MODEL_NOT_EMBEDDING': 422,
  'LLM.MODEL_NOT_FOUND': 404,
  'LLM.MODEL_NOT_IN_CATALOG': 422,
  'LLM.MODEL_NOT_IN_ORG_ALLOWLIST': 404,
  'LLM.MODEL_OUT_OF_CLASS': 422,
  'LLM.NO_EMBEDDING_MODEL_AVAILABLE': 403,
  'LLM.NO_EVALUATION_MODEL_AVAILABLE': 422,
  'LLM.OUTPUT_EMPTY': 502,
  'LLM.OUTPUT_UNPARSEABLE': 502,
  'LLM.PARAM_REJECTED': 422,
  'LLM.PROVIDER_AUTH_FAILED': 502,
  'LLM.PROVIDER_BAD_REQUEST': 422,
  'LLM.PROVIDER_DISABLED': 403,
  'LLM.PROVIDER_ENDPOINT_MISCONFIGURED': 502,
  'LLM.PROVIDER_NOT_FOUND': 404,
  'LLM.PROVIDER_QUOTA_EXHAUSTED': 502,
  'LLM.PROVIDER_RATE_LIMITED': 503,
  'LLM.PROVIDER_TIMEOUT': 504,
  'LLM.PROVIDER_UNREACHABLE': 503,
  'LLM.PROVIDER_VALIDATION_FAILED': 502,
  'LLM.UPSTREAM_FAILED': 502,
  'LLM.UPSTREAM_TIMEOUT': 504,
  'PPA.ARCHIVE_REJECTED': 422,
  'PPA.CHECKLIST_SUGGESTION_STALE': 409,
  'PPA.CONFLICT_ALREADY_RESOLVED': 409,
  'PPA.FACT_SUPERSEDED': 409,
  'PPA.FILE_TOO_LARGE': 413,
  'PPA.INGESTION_RUNNING': 409,
  'PPA.INVALID_RESULT_FOR_DIMENSION': 422,
  'PPA.INVALID_STATUS_TRANSITION': 409,
  'PPA.NO_DEFAULT_FRAMEWORK': 422,
  'PPA.NO_SOURCES': 422,
  'PPA.ORGANIZATION_ARCHIVED': 422,
  'PPA.VERSION_IMMUTABLE': 409,
  'PPA.VERSION_NOT_PUBLISHED': 409,
  'PPA.WORK_PRODUCT_APPROVED': 409,
  'PPA.WORK_PRODUCT_NOT_APPROVED': 409,
  'RESOURCE.ALREADY_EXISTS': 409,
  'RESOURCE.CONFLICT': 409,
  'RESOURCE.METHOD_NOT_ALLOWED': 405,
  'RESOURCE.NOT_FORWARDABLE': 409,
  'RESOURCE.NOT_FOUND': 404,
  'RESOURCE.RATE_LIMITED': 429,
  'SESSION.CONFIRM_TOKEN_EXPIRED': 409,
  'UPSTREAM.BAD_RESPONSE': 502,
  'UPSTREAM.TIMEOUT': 504,
  'UPSTREAM.UNAVAILABLE': 502,
  'VALIDATION.INVALID_WEIGHTS': 422,
  'VALIDATION.MALFORMED_REQUEST': 400,
  'VALIDATION.MODEL_CAPABILITY_MISSING': 422,
  'VALIDATION.PAYLOAD_TOO_LARGE': 413,
  'VALIDATION.REQUEST_INVALID': 422,
  'VALIDATION.SCHEMA_MISMATCH': 422,
  'VALIDATION.UNSUPPORTED_MEDIA_TYPE': 415,
  'VALIDATION.OBJECTIVE_NOT_RESEARCHABLE': 400,
  'ZENVECTOR.DIMENSION_MISMATCH': 422,
  'ZENVECTOR.MIGRATION_IN_PROGRESS': 409,
  'ZENVECTOR.MIGRATION_STATE_INVALID': 409,
  'ZENVECTOR.MODEL_NOT_EMBEDDING': 400,
  'ZENVECTOR.NAMESPACE_NOT_FOUND': 404,
}

export const PROBLEM_TYPE_URIS: Record<KnownErrorCode, string> = {
  'ACCESS.ORG_SCOPE_VIOLATION':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/access/org-scope-violation',
  'ACCESS.PERMISSION_DENIED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/access/permission-denied',
  'ACCESS.WORKSPACE_NOT_ALLOWED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/access/workspace-not-allowed',
  'AUTH.FORBIDDEN': 'https://scorpio.awsp.oraczen.xyz/docs/errors/auth/forbidden',
  'AUTH.INVALID_CREDENTIALS':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/auth/invalid-credentials',
  'AUTH.SERVICE_TOKEN_UNAVAILABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/auth/service-token-unavailable',
  'AUTH.TOKEN_EXPIRED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/auth/token-expired',
  'AUTH.TOKEN_MISSING': 'https://scorpio.awsp.oraczen.xyz/docs/errors/auth/token-missing',
  'AUTH.UNAUTHENTICATED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/auth/unauthenticated',
  'CONFIG.ORG_NOT_PROVISIONED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/config/org-not-provisioned',
  'CONFIG.ORG_PROVISIONING_FAILED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/config/org-provisioning-failed',
  'CONFIG.ORG_PROVISIONING_INCOMPLETE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/config/org-provisioning-incomplete',
  'CONFIG.PROVIDER_CREDENTIALS_INVALID':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/config/provider-credentials-invalid',
  'CONFIG.SECRET_MISSING': 'https://scorpio.awsp.oraczen.xyz/docs/errors/config/secret-missing',
  'DATA.EXTRACTION_PROFILE_CONFLICT':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/data/extraction-profile-conflict',
  'DATA.PIPELINE_INPUT_INVALID':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/data/pipeline-input-invalid',
  'DATA.PIPELINE_STAGE_CRASHED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/data/pipeline-stage-crashed',
  'DATA.QUERY_FAILED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/data/query-failed',
  'DATA.QUERY_TIMEOUT': 'https://scorpio.awsp.oraczen.xyz/docs/errors/data/query-timeout',
  'DATA.SCOPE_INVALID': 'https://scorpio.awsp.oraczen.xyz/docs/errors/data/scope-invalid',
  'DATA.BACKFILL_CONFIRMATION_REQUIRED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/data/backfill-confirmation-required',
  'EVALZEN.FILTER_REQUIRED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/filter-required',
  'EVALZEN.TOOL_UNKNOWN': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/tool-unknown',
  'EVALZEN.SUITE_NOT_FOUND': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/suite-not-found',
  'EVALZEN.SUITE_EXISTS': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/suite-exists',
  'EVALZEN.SUITE_EMPTY': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/suite-empty',
  'EVALZEN.PLATFORM_SUITE_READONLY':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/platform-suite-readonly',
  'EVALZEN.CASE_EXISTS': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/case-exists',
  'EVALZEN.CASE_NOT_FOUND': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/case-not-found',
  'EVALZEN.PIN_INVALID': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/pin-invalid',
  'EVALZEN.INPUT_INVALID': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/input-invalid',
  'EVALZEN.PLATFORM_ONLY_SUITE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/platform-only-suite',
  'EVALZEN.EXPECTED_OUTPUT_INVALID':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/expected-output-invalid',
  'EVALZEN.THRESHOLDS_INVALID':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/thresholds-invalid',
  'EVALZEN.RUN_NOT_FOUND': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/run-not-found',
  'EVALZEN.RUN_IN_PROGRESS': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/run-in-progress',
  'EVALZEN.JOB_NOT_FOUND': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/job-not-found',
  'EVALZEN.NO_BASELINE': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/no-baseline',
  'EVALZEN.BASELINE_RUN_INVALID':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/baseline-run-invalid',
  'EVALZEN.LANGFUSE_UNAVAILABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/langfuse-unavailable',
  'EVALZEN.CONFIG_MISSING': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/config-missing',
  'EVALZEN.CANDIDATE_NOT_SERVED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/candidate-not-served',
  'EVALZEN.CANDIDATE_NOT_EXERCISED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/candidate-not-exercised',
  'EVALZEN.TOOL_COST_CEILING':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/tool-cost-ceiling',
  'EVALZEN.TIER_CAP_EXCEEDED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/tier-cap-exceeded',
  'EVALZEN.RUNNER_NOT_PROVISIONED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/runner-not-provisioned',
  'EVALZEN.EVAL_WORKSPACE_UNRESOLVED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/eval-workspace-unresolved',
  'EVALZEN.AGENT_UNAVAILABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/agent-unavailable',
  'EVALZEN.TAXONOMY_NOT_CONFIGURED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/taxonomy-not-configured',
  'EVALZEN.REQUIREMENT_NOT_MET':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/requirement-not-met',
  'EVALZEN.RUNNER_FORBIDDEN':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/runner-forbidden',
  'EVALZEN.AGENT_TIMEOUT': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/agent-timeout',
  'EVALZEN.TRACE_UNAVAILABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/trace-unavailable',
  'EVALZEN.GATE_IN_PROGRESS':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/gate-in-progress',
  'EVALZEN.GATE_NOT_PASSED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/gate-not-passed',
  'EVALZEN.GATE_NOT_COVERED_UNACKNOWLEDGED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/gate-not-covered-unacknowledged',
  'EVALZEN.REVIEW_NOT_ENABLED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/review-not-enabled',
  'EVALZEN.REVIEW_QUEUE_MISSING':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/review-queue-missing',
  'EVALZEN.REVIEW_UNSUPPORTED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/review-unsupported',
  'EVALZEN.REVIEW_CONFIG_CONFLICT':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/review-config-conflict',
  'EVALZEN.IMPORT_IN_PROGRESS':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/import-in-progress',
  'EVALZEN.SUITE_ARCHIVED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/suite-archived',
  'EVALZEN.ORG_AGENT_SUITE_UNSUPPORTED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/evalzen/org-agent-suite-unsupported',
  'INTERNAL.CACHE_UNAVAILABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/internal/cache-unavailable',
  'INTERNAL.UNAVAILABLE': 'https://scorpio.awsp.oraczen.xyz/docs/errors/internal/unavailable',
  'INTERNAL.UNHANDLED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/internal/unhandled',
  'LLM.AGENT_NOT_FOUND': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/agent-not-found',
  'LLM.BUDGET_EXHAUSTED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/budget-exhausted',
  'LLM.CALL_TIMEOUT': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/call-timeout',
  'LLM.CONTEXT_TOO_LARGE': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/context-too-large',
  'LLM.DIMENSIONS_NOT_CONFIGURABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/dimensions-not-configurable',
  'LLM.DISPATCH_EXHAUSTED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/dispatch-exhausted',
  'LLM.KEY_NOT_CONFIGURED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/key-not-configured',
  'LLM.KEY_LOOKUP_UNAVAILABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/key-lookup-unavailable',
  'LLM.MODEL_CLASS_ENDPOINT_MISMATCH':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-class-endpoint-mismatch',
  'LLM.MODEL_CLASS_NOT_COVERED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-class-not-covered',
  'LLM.MODEL_CLASS_STRANDED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-class-stranded',
  'LLM.MODEL_DISABLED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-disabled',
  'LLM.MODEL_KILL_SWITCHED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-kill-switched',
  'LLM.MODEL_NOT_ASSIGNED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-not-assigned',
  'LLM.MODEL_NOT_EMBEDDING': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-not-embedding',
  'LLM.MODEL_NOT_FOUND': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-not-found',
  'LLM.MODEL_NOT_IN_CATALOG':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-not-in-catalog',
  'LLM.MODEL_NOT_IN_ORG_ALLOWLIST':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-not-in-org-allowlist',
  'LLM.MODEL_OUT_OF_CLASS': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/model-out-of-class',
  'LLM.NO_EMBEDDING_MODEL_AVAILABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/no-embedding-model-available',
  'LLM.NO_EVALUATION_MODEL_AVAILABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/no-evaluation-model-available',
  'LLM.OUTPUT_EMPTY': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/output-empty',
  'LLM.OUTPUT_UNPARSEABLE': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/output-unparseable',
  'LLM.PARAM_REJECTED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/param-rejected',
  'LLM.PROVIDER_AUTH_FAILED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/provider-auth-failed',
  'LLM.PROVIDER_BAD_REQUEST':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/provider-bad-request',
  'LLM.PROVIDER_DISABLED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/provider-disabled',
  'LLM.PROVIDER_ENDPOINT_MISCONFIGURED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/provider-endpoint-misconfigured',
  'LLM.PROVIDER_NOT_FOUND': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/provider-not-found',
  'LLM.PROVIDER_QUOTA_EXHAUSTED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/provider-quota-exhausted',
  'LLM.PROVIDER_RATE_LIMITED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/provider-rate-limited',
  'LLM.PROVIDER_TIMEOUT': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/provider-timeout',
  'LLM.PROVIDER_UNREACHABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/provider-unreachable',
  'LLM.PROVIDER_VALIDATION_FAILED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/provider-validation-failed',
  'LLM.UPSTREAM_FAILED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/upstream-failed',
  'LLM.UPSTREAM_TIMEOUT': 'https://scorpio.awsp.oraczen.xyz/docs/errors/llm/upstream-timeout',
  'PPA.ARCHIVE_REJECTED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/archive-rejected',
  'PPA.CHECKLIST_SUGGESTION_STALE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/checklist-suggestion-stale',
  'PPA.CONFLICT_ALREADY_RESOLVED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/conflict-already-resolved',
  'PPA.FACT_SUPERSEDED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/fact-superseded',
  'PPA.FILE_TOO_LARGE': 'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/file-too-large',
  'PPA.INGESTION_RUNNING': 'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/ingestion-running',
  'PPA.INVALID_RESULT_FOR_DIMENSION':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/invalid-result-for-dimension',
  'PPA.INVALID_STATUS_TRANSITION':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/invalid-status-transition',
  'PPA.NO_DEFAULT_FRAMEWORK':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/no-default-framework',
  'PPA.NO_SOURCES': 'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/no-sources',
  'PPA.ORGANIZATION_ARCHIVED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/organization-archived',
  'PPA.VERSION_IMMUTABLE': 'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/version-immutable',
  'PPA.VERSION_NOT_PUBLISHED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/version-not-published',
  'PPA.WORK_PRODUCT_APPROVED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/work-product-approved',
  'PPA.WORK_PRODUCT_NOT_APPROVED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/ppa/work-product-not-approved',
  'RESOURCE.ALREADY_EXISTS': 'https://scorpio.awsp.oraczen.xyz/docs/errors/resource/already-exists',
  'RESOURCE.CONFLICT': 'https://scorpio.awsp.oraczen.xyz/docs/errors/resource/conflict',
  'RESOURCE.METHOD_NOT_ALLOWED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/resource/method-not-allowed',
  'RESOURCE.NOT_FORWARDABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/resource/not-forwardable',
  'RESOURCE.NOT_FOUND': 'https://scorpio.awsp.oraczen.xyz/docs/errors/resource/not-found',
  'RESOURCE.RATE_LIMITED': 'https://scorpio.awsp.oraczen.xyz/docs/errors/resource/rate-limited',
  'SESSION.CONFIRM_TOKEN_EXPIRED':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/session/confirm-token-expired',
  'UPSTREAM.BAD_RESPONSE': 'https://scorpio.awsp.oraczen.xyz/docs/errors/upstream/bad-response',
  'UPSTREAM.TIMEOUT': 'https://scorpio.awsp.oraczen.xyz/docs/errors/upstream/timeout',
  'UPSTREAM.UNAVAILABLE': 'https://scorpio.awsp.oraczen.xyz/docs/errors/upstream/unavailable',
  'VALIDATION.INVALID_WEIGHTS':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/validation/invalid-weights',
  'VALIDATION.MALFORMED_REQUEST':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/validation/malformed-request',
  'VALIDATION.MODEL_CAPABILITY_MISSING':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/validation/model-capability-missing',
  'VALIDATION.PAYLOAD_TOO_LARGE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/validation/payload-too-large',
  'VALIDATION.REQUEST_INVALID':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/validation/request-invalid',
  'VALIDATION.SCHEMA_MISMATCH':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/validation/schema-mismatch',
  'VALIDATION.UNSUPPORTED_MEDIA_TYPE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/validation/unsupported-media-type',
  'VALIDATION.OBJECTIVE_NOT_RESEARCHABLE':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/validation/objective-not-researchable',
  'ZENVECTOR.DIMENSION_MISMATCH':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/zenvector/dimension-mismatch',
  'ZENVECTOR.MIGRATION_IN_PROGRESS':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/zenvector/migration-in-progress',
  'ZENVECTOR.MIGRATION_STATE_INVALID':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/zenvector/migration-state-invalid',
  'ZENVECTOR.MODEL_NOT_EMBEDDING':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/zenvector/model-not-embedding',
  'ZENVECTOR.NAMESPACE_NOT_FOUND':
    'https://scorpio.awsp.oraczen.xyz/docs/errors/zenvector/namespace-not-found',
}
